// Key strings are a wire format: renaming one orphans existing stored values.

export const STORAGE_KEYS = {
  FILTER_CACHE: 'filterCache',
  EXECUTIONS_FILTER: 'executionsFilter',
  LEFT_NAV_STATE: 'LeftNavState',
  INTEGRATION_HEALTH_VIEW: 'integrationHealthView',
  NEEDS_ATTENTION_VIEW: 'needsAttentionView',
  IMPORT_LOCATION_ID: 'importLocationId',
  IMPORT_LOCATION_INTEGRATION_ID: 'importLocationIntegrationId',
  SHOULD_DISPLAY_NOTIFICATION: 'shouldDisplayNotification',
  BETA_FEATURES: 'betaFeatures',
  THEME_MODE: 'themeMode',
  NIGHT_PALETTE: 'nightPalette',
  HOME_LAYOUT: 'homeLayout',
  RESOLVED_THEME: 'resolvedTheme',
};

export const STORAGE_PREFIXES = {
  CHANGE_HISTORY_FILTERS: 'changeHistoryFilters_',
  CHANGE_HISTORY_SETTINGS: 'changeHistorySettings_',
};

const scopedKey = (prefix, integrationId, locationId) => {
  if (!integrationId) return null;

  return `${prefix}${integrationId}${locationId ? `_${locationId}` : ''}`;
};

export const changeHistoryFiltersKey = (integrationId, locationId) =>
  scopedKey(STORAGE_PREFIXES.CHANGE_HISTORY_FILTERS, integrationId, locationId);

export const changeHistorySettingsKey = (integrationId, locationId) =>
  scopedKey(
    STORAGE_PREFIXES.CHANGE_HISTORY_SETTINGS,
    integrationId,
    locationId,
  );
